import { ReactElement, KeyboardEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { BriefcaseFillIcon, ExternalLinkIcon } from '@navikt/aksel-icons';
import { Routes } from '../../enums/Routes';
import classes from './PartnerAdminTopBar.module.css';

const LINK_TEXT = 'Gå til Trustpulse';
const LINK_ARIA_LABEL = 'Gå til Trustpulse';

export const PartnerAdminTopBar = (): ReactElement => {
  const navigate = useNavigate();

  const navigateToDashboard = () => {
    navigate(Routes.Dashboard);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLAnchorElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      navigateToDashboard();
    }
  };

  return (
    <div className={classes.banner}>
      <div className={classes.content}>
        <div className={classes.leftSection}>
          <BriefcaseFillIcon className={classes.icon} aria-hidden="true" />
          <span className={classes.portalLabel}>Partner-portal</span>
        </div>
        <a
          className={classes.link}
          onClick={navigateToDashboard}
          onKeyDown={handleKeyDown}
          role="button"
          tabIndex={0}
          aria-label={LINK_ARIA_LABEL}
        >
          <span>{LINK_TEXT}</span>
          <ExternalLinkIcon className={classes.linkIcon} aria-hidden="true" />
        </a>
      </div>
    </div>
  );
};
